import { Nullable } from '@kts-front/types';
import { z } from 'zod';

import { PlaceTypeEntityApi } from 'entities/PlaceType';

import { ReadinessDate } from './ReadinessDate';
import { ReservationInfoModel } from './ReservationInfoModel';

export const lotStatusBadgeSchema = z.enum(['wait_payment', 'cancelled', 'payed']);

export type LotStatusBadge = z.output<typeof lotStatusBadgeSchema>;

export interface NamedEntity {
  id: number;
  name: string;
}

export interface Range {
  from: number;
  to: string;
}

export interface ImageEntity extends NamedEntity {
  url: string;
}

export enum LotApartmentLayoutType {
  euro = 'EURO',
  studio = 'STUDIO',
  none = 'NONE',
  unknown = 'UNKNOWN',
}

export interface LotApartmentAttributesServer {
  layout_type: Nullable<LotApartmentLayoutType>;
  cardinal_directions: Nullable<string>;
  window_view: Nullable<string>;
  section: Nullable<string>;
}

export interface LotServer {
  id: number;
  is_favorite: boolean;
  is_hidden: boolean;
  apartment_number: string;
  section: Nullable<NamedEntity>;
  keys_handover_at: Nullable<string>;
  floor: number;
  area: number;
  /**
   * 0 комнат = студия
   */
  rooms: number;
  apartment_decorations: NamedEntity[];
  view_direction: NamedEntity;
  reserved: Nullable<boolean>;
  ready: Nullable<boolean>;
  price: number;
  price_full_payment: number;
  price_promotional: Nullable<number>;
  flat_plan: string;
  place_type: PlaceTypeEntityApi;
  project: NamedEntity;
  images: ImageEntity[];
  status_badge: LotStatusBadge;
  reservation_info: ReservationInfoModel;
  readiness_date: Nullable<ReadinessDate>;
  apartment_attributes: Nullable<LotApartmentAttributesServer>;
}

export interface LotFiltersServer {
  projects: {
    id: number;
    name: string;
    sections: NamedEntity[];
  }[];
  price: Range;
  floor: Range;
  area: Range;
  window_views: NamedEntity[];
  apartment_decorations: NamedEntity[];
  layout_types: LotApartmentLayoutType[];
  apartment_sections: string[];
}

export interface LotListServer {
  items: LotServer[];
  total: number;
}

export type AddFavoriteLotRequest = {
  lot_id: number;
};

export type FavoriteLotResult = {
  lot_id: number;
  is_favorite: boolean;
};

export interface LotFiltersListServer {
  items: LotFiltersServer;
  total: number;
}
